import React from 'react'

import { MobileOutletServicePopover } from '@src/components/SiteHeader/ServiceNavigation/Popovers/MobileOutletServicePopover'
import { NarrowFulfilmentMethodInputType } from '@src/graphql-types'
import { useAllDiscountsQuery } from '@src/hooks/sharedQueries/useAllDiscounts/useAllDiscounts'
import { useBreakpoint } from '@src/hooks/useBreakpoint'
import { useBottomSheetStack } from '@src/hooks/useBottomSheetStack/useBottomSheetStack'

import { HeaderTab, TabString } from './HeaderTab'
import { OutletHeaderMobile } from './OutletHeaderMobile'
import { ServiceTabsContainer } from './OutletHeaderStyles'
import { useOutletPageContext } from '../OutletPageContext'

export const FulfilmentMethodTabMap: Record<
  NarrowFulfilmentMethodInputType,
  TabString[]
> = {
  [NarrowFulfilmentMethodInputType.TABLE]: [
    TabString.SERVICE,
    TabString.LOCATION,
  ],
  [NarrowFulfilmentMethodInputType.COLLECTION]: [
    TabString.SERVICE,
    TabString.WHEN,
  ],
  [NarrowFulfilmentMethodInputType.DELIVERY]: [
    TabString.SERVICE,
    TabString.WHEN,
    TabString.WHERE,
  ],
}

export const OutletHeader: React.FC = () => {
  const { serviceComponentBottomSheetController } = useBottomSheetStack()
  const {
    isCollapsingDivVisible: compactStyle,
    outletFulfilment: {
      outlet,
      data: { currentFulfilment },
    },
  } = useOutletPageContext()

  const { isTabletOrGreater } = useBreakpoint()
  const { data, previousData } = useAllDiscountsQuery({
    outletId: outlet.id,
    fulfilmentNarrowType: currentFulfilment.narrowType,
  })

  const selectedNarrowFulfilment = currentFulfilment.narrowType

  const hideTableTab =
    currentFulfilment.narrowType === NarrowFulfilmentMethodInputType.TABLE &&
    outlet.isPendingTableNumbersEnabled

  const fulfilmentTabs = hideTableTab
    ? [TabString.SERVICE]
    : FulfilmentMethodTabMap[selectedNarrowFulfilment]
  const hasDiscounts = Boolean(
    (data || previousData)?.allDiscountsByOutletId?.length
  )

  return (
    <>
      <ServiceTabsContainer
        onClick={serviceComponentBottomSheetController.open}
        compactStyle={compactStyle}
        hasOffers={hasDiscounts && outlet.restaurant.dealsText !== null}
      >
        {isTabletOrGreater ? (
          <HeaderTab
            fulfilmentTabs={fulfilmentTabs}
            dataTestId="outlet-header-container-servicetabs"
          />
        ) : (
          <OutletHeaderMobile
            selectedNarrowFulfilment={currentFulfilment.narrowType}
          />
        )}
      </ServiceTabsContainer>
      <MobileOutletServicePopover />
    </>
  )
}
